module.exports = __webpack_public_path__ + "19061bd890c85620d9d8f42bdcf6f101.png";